import {
  analyticsConfig,
  EVENTS,
  isKnownEventName,
  sanitizeEventProps,
} from "./config"
import {
  getConsentPreferences,
  saveConsentPreferences,
  setDefaultGoogleConsent,
} from "./consent"
import {
  initializeMarketing,
  applyMarketingConsent,
  trackMarketingEvent,
  trackMarketingPageView,
} from "./marketing"
import { initializePlausible, trackPlausibleEvent } from "./plausible"

const warnUnknownEvent = eventName => {
  if (
    process.env.NODE_ENV !== "production" &&
    typeof console !== "undefined" &&
    !isKnownEventName(eventName)
  ) {
    console.warn(`[analytics] Unknown event: ${eventName}`)
  }
}

export const initializeAnalytics = () => {
  initializePlausible()

  if (analyticsConfig.marketing.requested) {
    setDefaultGoogleConsent()
    initializeMarketing()
  }
}

export const applyConsentPreferences = preferences => {
  const consent = saveConsentPreferences(preferences)
  applyMarketingConsent(consent.preferences)
  return consent
}

export const trackPageView = location => {
  trackMarketingPageView(location)
}

export const trackEvent = (eventName, props = {}) => {
  warnUnknownEvent(eventName)

  const safeProps = sanitizeEventProps(props)
  trackPlausibleEvent(eventName, safeProps)
  trackMarketingEvent(eventName, safeProps)
}

export const trackConversion = (eventName = EVENTS.PURCHASE_COMPLETED, props) =>
  trackEvent(eventName, props)

export {
  analyticsConfig,
  EVENTS,
  getConsentPreferences,
  saveConsentPreferences,
}
